<div class="grid-container margin-top margin-bottom-large wrapper">
  <form [formGroup]="form">
    @if (application) {
      <div class="grid-x grid-margin-x section">
        <div class="grid-x grid-margin-x section">
          <div class="cell small-12 medium-12 large-12 bold padding-left">
            Download Files:
          </div>
          <div class="cell small-12 medium-12 large-12 padding-left">
            <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            <upload-view-files [uniqueId]="'uploader'" [files]="storedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="false" [allowUpload]="false">
            </upload-view-files>
          </div>
        </div>
      </div>
      <hr />
      <label for="receivedDate">Date Plugging Report Received</label>
      <view-notes [fieldName]="'receivedDate'" [notes]="getFilteredNotes('receivedDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      <common-date-picker [id]="'receivedDate'" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate" [disabled]="form?.get('receivedDate').disabled"></common-date-picker>
      <label for="plugDate">Plug Date</label>
      <view-notes [fieldName]="'plugDate'" [notes]="getFilteredNotes('plugDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      <common-date-picker [id]="'plugDate'" (dateUpdated)="onDateUpdated($event, 'plugDate')" [initialDate]="plugDate" [disabled]="form?.get('plugDate')?.disabled" ></common-date-picker>
      <label for="replugDate">Re-Plug Date</label>
      <view-notes [fieldName]="'replugDate'" [notes]="getFilteredNotes('replugDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      <common-date-picker [id]="'replugDate'" (dateUpdated)="onDateUpdated($event, 'replugDate')" [initialDate]="replugDate" [disabled]="form?.get('replugDate')?.disabled"></common-date-picker>
      <div class="grid-x grid-margin-x">
        <div class="large-12 medium-12 small-12 text-align-center">
          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onAccept()">Accept</button>
            </span>
          }
          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onReturn()">Return For Corrections</button>
            </span>
          }
          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onSave()">Save for Later</button>
            </span>
          }
          <span>
            <button class="button" (click)="cancel()">Cancel</button>
          </span>
        </div>
      </div>
    }



  </form>
</div>


